import { Tabs } from 'antd';

import { useAppSelector } from 'app/store';

import { viewerModel } from 'entities/viewer';

import { configTabs } from 'shared/helpers/utils';
import { RolesUser } from 'shared/enums';
import { useTabsNavigate } from 'shared/hooks';

import ReportVacations from './reportVacations';
import ReportReferences from './reportReferences';
import ReportConsultations from './reportConsultations';
import style from './index.module.scss';

const itemsTab = [
  {
    label: 'Справки',
    key: 'reportReferences',
    children: <ReportReferences />,
    role: [RolesUser.HRDirector, RolesUser.Consultant],
  },
  {
    label: 'Консультации',
    key: 'constultations',
    children: <ReportConsultations />,
    role: [RolesUser.HRDirector, RolesUser.Consultant],
  },
  {
    label: 'Отпуск',
    key: 'vacations',
    children: <ReportVacations />,
    role: [RolesUser.HRDirector, RolesUser.Consultant],
  },
  // {
  //   label: 'Неявки',
  //   key: 'absence',
  //   children: <ReportAbsence />,
  //   role: [RolesUser.HRDirector, RolesUser.HRSupervisor],
  // },
  // {
  //   label: 'Отгулы',
  //   key: 'dayOff',
  //   children: <ReportDayOff />,
  //   role: [RolesUser.HRDirector, RolesUser.HRSupervisor],
  // },
];

export const Reports = () => {
  const [activeTab, handler] = useTabsNavigate('reports', itemsTab[0].key);
  const { role } = useAppSelector(viewerModel.me.selectors.selectViewerProfile);
  const tabPane = configTabs(role, itemsTab);

  return (
    <div className={style.reportsWrap}>
      <Tabs defaultActiveKey="reportVacations" activeKey={activeTab} onChange={handler} destroyInactiveTabPane>
        {tabPane &&
          tabPane.map(el => {
            return (
              <Tabs.TabPane tab={el.label} key={el.key}>
                {el.children}
              </Tabs.TabPane>
            );
          })}
      </Tabs>
    </div>
  );
};
